import { BaseButton } from "../../../../components/Button/BaseButton.tsx";
import { upgradeDialogStore } from "../../../components/UpgradeDialog/upgradeDialogStore.ts";
import { rateLimitBannerStore } from "./rateLimitBannerStore.ts";

export const RateLimitBanner = () => {
  const { showRateLimitBanner, timeUntilReset } =
    rateLimitBannerStore.useState();
  return (
    showRateLimitBanner && (
      <div className="h-[40px] w-full flex-row items-center px-600 bg-surface-error-primary-rest text-error-primary label-md-default">
        <div className="flex-row items-center">
          You’ve reached your generation limit.
          {timeUntilReset && ` Reset in ${timeUntilReset}, wait or`}
          &nbsp;
          <BaseButton
            className="label-md-semibold underline"
            onClick={() => {
              upgradeDialogStore.openDialog();
            }}
          >
            Upgrade plan
          </BaseButton>
        </div>
      </div>
    )
  );
};
